import {dataTestId} from '@hconnect/uikit'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {ArrowForward, EditOutlined} from '@mui/icons-material'
import {Button, Stack, Box} from '@mui/material'
import {useCallback} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../consts'
import {
  useMaterialDemandEdit,
  useMaterialDemandFilters,
  useSelectedTimeframe
} from '../../../providers'

import {MaterialDemandFilterBar} from './MaterialDemandFilterBar'

export const MaterialDemandTableToolbar: React.FC = () => {
  const {selectedTimeframe} = useSelectedTimeframe()
  if (!selectedTimeframe) {
    throw new Error('BUG: Selected timeframe should be set to render this view')
  }
  const timezoneId = useUpmPlantTimezone()
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const {selectedDate} = useMaterialDemandFilters()
  const {isEditing, changeIsEditing} = useMaterialDemandEdit()

  const startEditing = useCallback(() => changeIsEditing(true), [changeIsEditing])
  const finishEditing = useCallback(() => changeIsEditing(false), [changeIsEditing])

  const editDisabled = !selectedDate

  return (
    <Stack direction="row" justifyContent="space-between">
      <MaterialDemandFilterBar timeframe={selectedTimeframe} timezoneId={timezoneId} />
      <Box flexShrink={0}>
        {isEditing ? (
          <Button
            {...dataTestId('table_edit_done_button')}
            color="primary"
            variant="contained"
            startIcon={<ArrowForward />}
            onClick={finishEditing}
          >
            {t('common.done')}
          </Button>
        ) : (
          <Button
            {...dataTestId('table_edit_button')}
            startIcon={<EditOutlined />}
            onClick={startEditing}
            disabled={editDisabled}
          >
            {t('common.edit')}
          </Button>
        )}
      </Box>
    </Stack>
  )
}
